import type { ComponentTemplate } from "schemas/generated/componentTemplates";

import { transformReviewsTemplateToUseProductForContextIfNecessary } from "./defaultComponentTemplate";

export const junipReviews: ComponentTemplate = {
  id: "a6ed9988-4900-4652-813b-1e71ee0f610e",
  storeId: null,

  scope: "left-bar",
  type: "component",
  name: "Product/Junip Product Reviews",
  leftBarCategory: { main: "productIntegrations", subCategory: "junip" },
  preview: "integrations/junip-product-reviews.svg",
  transforms: [transformReviewsTemplateToUseProductForContextIfNecessary],
  template: {
    id: "$uid",
    type: "junipReviews",
    props: {},
  },
};
